var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie',{attrs:{"options":{
    animationData: _vm.animationData,
    loop: true,
    autoplay: true
  },"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }